import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { NavLink } from "react-router-dom";
function AboutUs() {
    return (
        <>
            <Header />
            {/* Inner Slider */}
            <section class="inr-header">
                <div class="container">
                    <div class="inr-header-content">
                        <h1 class="title">About SMNS</h1>
                        <ul class="breadcrumb">
                            <li><NavLink to="/">Home</NavLink></li>
                            <li> About SMNS</li>
                        </ul>
                    </div>
                </div>
            </section>
            {/*  Inner Body */}
            <section className="innerBody">
                <div className="container them-container">
                    <div className="row">
                        <div className="col-12">
                            <h1>About St. Mary’s Nursery School, Bokaro (SMNS)</h1>
                            <p>
                                <b><i>“Where Every Child Begins with Confidence, Curiosity, and Care.”</i></b>
                            </p>

                            <p>
                                Established in <b>1976, St. Mary’s Nursery School (SMNS), Bokaro</b> stands as one of the most trusted and reputed names in early childhood education. An
                                <b> English Medium Co-educational Institution,</b> SMNS operates under the aegis of the
                                <b> St. Thomas Orthodox Church Mission, Bhilai, Chhattisgarh,</b> of the
                                <b> Indian Orthodox Church,</b> and is a proud unit of the
                                <b> M.G.M. Group of Educational Institutions.</b>
                            </p>

                            <p>
                                The school was founded by <b>Rev. Fr. P. T. Cherian</b> under the visionary guidance of
                                <b> Late Lamented H. G. Dr. Stephanos Mar Theodosius,</b> an eminent educationist and the
                                <b> Founder President</b> of the institution. Today, the school continues to grow and flourish under the blessings and leadership of
                                <b> H. G. Alexios Mar Eusebius,</b> the <b>current President.</b>
                            </p>

                            <p>
                                Over the past <b>50+ years,</b> SMNS has carved a distinguished place for itself in the
                                <b> Steel City of Bokaro,</b> earning admiration from parents and the community alike for its
                                <b> holistic, value-based, and child-centered education.</b> The school is widely regarded as the
                                <b> best foundation school</b> for a child’s first learning experience — blending play, creativity, and academics to lay a rock-solid base for lifelong learning.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <div className="clr100"></div>
            {/* Footer */}
            <Footer />
        </>
    )
}

export default AboutUs